import type { IEvent } from '../../../common/addressSearch/AddressSearch';

export const mapToPosition = (latitude: IEvent['latitude'], longitude: IEvent['longitude']) => ({
    latitude,
    longitude,
});
